<template>
  <div class="welcome-container">
    <el-card class="main-card">
      <div slot="header" class="card-header">
        <el-icon><i class="el-icon-s-home"></i></el-icon>
        <span class="header-text">Welcome!</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-alert
            :title="`👋 Hello, ${username}!`"
            type="info"
            effect="dark"
            class="alert-box alert-large"
          />
        </el-col>

        <el-col :span="24" v-if="SystemInformationList.filter(r => !r.seen).length > 0">
          <el-alert
            :title="`⚠️ ${SystemInformationList.filter(r => !r.seen).length} Unread System Information`"
            type="warning"
            show-icon
            effect="dark"
            class="alert-box alert-large"
          />
        </el-col>

        <el-col :span="24" v-if="InternalInformationList.filter(r => !r.seen).length > 0">
          <el-alert
            :title="`📢 ${InternalInformationList.filter(r => !r.seen).length} Unread Internal Information`"
            type="warning"
            show-icon
            effect="dark"
            class="alert-box alert-large"
           
          />
        </el-col>

        <el-col :span="24" v-if="sum !== 0 && userlevel < 2">
          <el-alert
            :title="`📅 ${sum} Vacation Leaves Pending Approval`"
            type="warning"
            show-icon
            effect="dark"
            class="alert-box alert-large"
            description="You have pending vacation requests to review."
          />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>


<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { systemInformation } from "../api/systeminformation/systeminformation";
import { internalInformation } from "../api/internalinformation/internalinformation";
import { vacation } from "../api/vacation";

@Component({
  name: "Welcome"
})
export default class Welcome extends Vue {
  public username: string = "";
  public SystemInformationList: any[] = [];
  public InternalInformationList: any[] = [];
  public viewVacationSubmitted: any[] = [];
  public loading: boolean = true;
  public sum: number = 0;
  public userlevel: number = 0;

  public async created() {
    this.loading = true;
    this.username = this.$store.getters.getUserName;
    await this.getVacationList();
    await this.getSysInfo();
    await this.getIntInfo();
    this.calculatePendingLeaves();
    this.userlevel = this.$store.getters.getUserLevel;
    this.loading = false;
  }

  public async getVacationList() {
    try {
      const response = await vacation.getAllVacations(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      );
      const data = await response.json();
      this.viewVacationSubmitted = JSON.parse(JSON.stringify(data));
    } catch (error) {
      console.error("Error fetching vacation list:", error);
    }
  }

  public calculatePendingLeaves() {
    this.sum = this.viewVacationSubmitted.filter(
      p => p.decision !== 2 && p.hours_req == null
    ).length;
  }

  public async getSysInfo() {
    try {
      const response = await systemInformation.getSomeMessages(
        this.$store.getters.getToken,
        {},
        this.$store.getters.getHost
      );
      const data = await response.json();
      this.SystemInformationList = JSON.parse(JSON.stringify(data));
      this.SystemInformationList.forEach(r => {
        r.seen = !r.system_information_seen.every(
          s => s.users.name !== this.$store.getters.getUserName
        );
      });
    } catch (error) {
      console.error("Error fetching system information:", error);
    }
  }

  public async getIntInfo() {
    try {
      const response = await internalInformation.getSomeMessages(
        this.$store.getters.getToken,
        {},
        this.$store.getters.getHost
      );
      const data = await response.json();
      this.InternalInformationList = JSON.parse(JSON.stringify(data));
      this.InternalInformationList.forEach(r => {
        r.seen = !r.internal_information_seen.every(
          s => s.users.name !== this.$store.getters.getUserName
        );
      });
    } catch (error) {
      console.error("Error fetching internal information:", error);
    }
  }
}
</script>

<style scoped>

.el-alert--warning {
    background-color: yellow;
    color: #303133;
}

.el-alert--info {
    background-color: lightgray;
    color: #303133;
}
.welcome-container {
  max-width: 900px;
  margin: 3rem auto;
  padding: 1rem;
}

.main-card {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
}

.card-header {
  display: flex;
  align-items: center;
  font-size: 1.8rem;
  font-weight: bold;
  color: #303133;
}

.card-header .el-icon {
  margin-right: 10px;
  font-size: 2rem;
  color: #409EFF;
}

.header-text {
  flex-grow: 1;
}

.alert-box {
  margin-bottom: 1.5rem;
}

.alert-large ::v-deep .el-alert__title {
  font-size: 1.4rem;
  font-weight: bold;
}

.alert-large ::v-deep .el-alert__description {
  font-size: 1.1rem;
  margin-top: 0.5rem;
}
</style>

